import { render, staticRenderFns } from "./TrafficInfomation.vue?vue&type=template&id=12d24b76&scoped=true&lang=pug"
import script from "./TrafficInfomation.vue?vue&type=script&lang=js"
export * from "./TrafficInfomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d24b76",
  null
  
)

export default component.exports